import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg className={styles["myhouse_main_resident--more"] || "myhouse_main_resident--more"} xmlns="http://www.w3.org/2000/svg" width="7" height="18" {...props}><path d="M.505 3.505a.701.701 0 01.903-.074l.087.074 5 5c.246.246.27.63.074.903l-.074.087-5 5a.7.7 0 01-1.064-.903l.074-.087L5.011 9 .505 4.495a.701.701 0 01-.074-.903l.074-.087z" fill="#6C7074" fillRule="nonzero" /></svg>);